import React from 'react';
import PropTypes from 'prop-types';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import { statsCounterSchema } from './schema';
import StatsCounterView from './StatsCounterView';

const StatsCounterEdit = ({ data, onChangeBlock, block, selected }) => {
  return (
    <>
      <StatsCounterView data={data} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={statsCounterSchema}
          title={statsCounterSchema.title}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

StatsCounterEdit.propTypes = {
  data: PropTypes.object.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  block: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default StatsCounterEdit;
